import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-own-parts-popup',
  templateUrl: './own-parts-popup.component.html',
  styleUrls: ['./own-parts-popup.component.scss'],
  standalone: false
})
export class OwnPartsPopupComponent {
  isMobile: boolean = false;
  private destroy$ = new Subject<void>();
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any,
    private breakpointObserver: BreakpointObserver,
    private dialogRef: MatDialogRef<OwnPartsPopupComponent>,

  ) {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }

  closeAcc(canupload: boolean) {
    this.dialogRef.close(canupload);
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
